module.exports = __webpack_public_path__ + "img/plumber_demo-400x300.d31bea22.jpg";